export enum OrderStageType {
  estimate = 'estimate',
  invoice = 'invoice',
  order = 'order',
  shipped = 'shipped',
  acknowledge = 'acknowledge',
  delivered = 'delivered',
  custom = 'custom',
}

export type OrderStageId = string;
export interface OrderStageResponse {
  id: OrderStageId;
  name: string;
  type: OrderStageType;
  menuOrder: number;
  canDelete: boolean;
  active: boolean;
}
